module.exports = "<app-header></app-header>\r\n<app-body></app-body>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/roche/roche/src/app/layouts/full-layout.component.html
// module id = ../../../../../src/app/layouts/full-layout.component.html
// module chunks = main